import { uniqueId } from '../../utils/data';
import { frame } from '../../utils/drawing';
import Blazy from 'blazy';
/**
 * @module directives/scroll/lazy-load
 */

/**
 * Lazily loads images, backgrounds, videos and iframes.
 * @see http://dinbror.dk/blog/blazy/
 * @param {HTMLElement} [context=document.body] - Optional DOM context.
 */
export default function lazyLoadDirective(context = document.body) {
  let container = 'window';
  if (context !== document.body) {

    // Blazy needs a string selector, so if we aren't in body context build it off the element, or put one on
    container = context.tagName.toLowerCase();
    if (context.getAttribute('id')) {
      container += '#' + context.getAttribute('id');
    } else {
      const id = `data-blazy-${uniqueId()}`;
      context.setAttribute(id, "true");
      container += `[${id}]`;
    }
  }

  // Create the blazy, revalidate on load
  const blazy = new Blazy({
    container,
    selector: '[data-sw-lazy-load]',
    src: 'data-sw-lazy-load',
    successClass: 'lazy-is-ready',
    errorClass: 'lazy-is-broken',
  });
  
  window.addEventListener('load', blazy.revalidate);
}



// WEBPACK FOOTER //
// ./source/scripts/directives/scroll/lazy-load.js